import { Box } from "@mui/system";
import ModalTrigger from "../Common/ModalTrigger";

import BovineBlue from "../../Assets/bovine_fat_blue.svg";
import CarrotsBlue from "../../Assets/aubergines_blue.svg";
import CauliflowerBlue from "../../Assets/bananas_blue.svg";
import KiwiBlue from "../../Assets/broccoli_blue.svg";
import OnionsBlue from "../../Assets/cultivated_fungi_blue.svg";
import OrangesBlue from "../../Assets/grapefruits_blue.svg";
import PearsBlue from "../../Assets/melons_blue.svg";
import PotatoesBlue from "../../Assets/sweet_bell_peppers_blue.svg";
import PoultryBlue from "../../Assets/chicken_eggs_blue.svg";
import RiceBlue from "../../Assets/virgin_olive_oil_blue.svg";
import RyeBlue from "../../Assets/wheat_blue.svg";
import GrapesBlue from "../../Assets/table_grapes_blue.svg";

const data = [
  {
    filter: "Table grapes",
    image: GrapesBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 926 samples of table grapes were analysed. No{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found in 10.3% (95) of samples. In 4.3% (40) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 1.6% (15) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 78.0% (722) of samples. In one table grape sample grown in a third country, 16 pesticides were reported: famoxadone, flonicamid, acetamiprid, azoxystrobin, boscalid, cyprodinil, difenoconazole, fenvalerate, fluopyram, flupyradifurone, lambda-cyhalothrin, penconazole, pyrimethanil, trifloxystrobin, malathion and spirotetramat. This result was non-compliant due to two pesticides.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Bovine fat",
    image: BovineBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 939 samples of bovine fat were analysed. No{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found in 84.8% (796) of samples. In 0.2% (2) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 0.1% (1) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 0.7% (7) of samples. For one bovine fat sample from the EU, three different pesticides were reported: hexachlorobenzene, DDT and copper. The results were within the permissible levels.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Aubergines",
    image: CarrotsBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 860 aubergine samples were analysed. No{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were detected in 44.4% (382) of samples. In 2.2% (19) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 0.7% (6) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 23.4% (201) of samples. In one EU-grown aubergine sample, 9 different pesticides were reported: flonicamid, chlorantraniliprole, cypermethrin, cyprodinil, dimethomorph, fludioxoni, propamocarb, pyriproxyfen and ametoctradin. All results were within the permissible level.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Bananas",
    image: CauliflowerBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 835 banana samples were analysed. No{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were detected in 19% (159) of samples. In 1.6% (13) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 0.4% (3) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 66.1% (552) of samples. In ten banana samples (all of them grown in third countries), seven different pesticide residues were reported. The pesticides found in the samples were: fenpropimorph, pyriproxyfen, thiabendazole, fosetyl, glufosinate equivalents, fludioxonil, spirotetramat, pyrimethanil, dithiocarbamates, fenpropidin and myclobutanil. All results were within the permissible level.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Broccoli",
    image: KiwiBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 772 broccoli samples were analysed. No{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found in 42.4% (327) of samples. In 2.2% (17) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 1.4% (11) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 29.3% (226) of samples. In two EU-grown broccoli samples, nine different pesticides were reported. The pesticides found in the samples were: acetamiprid, azoxystrobin, boscalid, chlorantraniliprole, copper, difenoconazole, fluxapyroxad, fosetyl, lambda-cyhalothrin, metalaxyl and metalaxyl-M, propamocarb, pyraclostrobin and spirotetramat. All results were within the permissible level.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Cultivated fungi",
    image: OnionsBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 807 samples of cultivated fungi were analysed. No{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found in 45.1% (364) of samples. In 2.2% (18) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 1.2% (10) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 21.9% (177) of samples. In one EU-grown cultivated fungi sample, six different pesticides were reported: chlormequat-chloride, mepiquat chloride, fosetyl, copper, diflubenzuron and prochloraz. All results were within the permissible level.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Grapefruits",
    image: OrangesBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 816 samples of grapefruits were analysed. No{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found in 10.9% (89) of samples. In 3.7% (30) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 2% (16) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 73.5% (600) of samples. In one grapefruit sample grown in a third country, 13 different pesticides were reported: glyphosate, fosetyl, glufosinate equivalents, copper, azoxystrobin, buprofezin, fludioxonil, imazalil, methoxyfenozide, pyraclostrobin, pyrimethanil, pyriproxyfen and thiabendazole. All results were within the permissible level.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Melons",
    image: PearsBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 776 samples of melons were analysed. No{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found in 41.1% (319) of samples. In 1.8% (14) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 0.8% (6) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 39.0% (303) of samples. In one EU-grown melon sample, 12 different pesticides were reported: copper, acetamiprid, azoxystrobin, chlorantraniliprole, cyazofamid, flonicamid, fluopicolide, fluopyram, propamocarb, trifloxystrobin, dithiocarbamates and fosetyl. All results were within the permissible level.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Sweet\/bell peppers",
    image: PotatoesBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 1,180 samples of sweet/bell peppers were analysed. No{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found in 40.6% (479) of samples. In 4.7% (55) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 3.3% (39) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 37.3% (440) of samples. In one sweet/bell pepper sample grown in a third country, 17 pesticides were reported: acetamiprid, acrinathrin, azoxystrobin, boscalid, cyantraniliprole, cypermethrin, cyprodinil, deltamethrin, difenoconazole, fludioxonil, fluopyram, pyridaben, pyrimethanil, pyraclostrobin, tebuconazole, spirotetramat and copper. All results were within the permissible level.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Chicken eggs",
    image: PoultryBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 786 samples of chicken eggs were analysed. No{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found in 80.7% (634) of samples. In 1.4% (11) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            {"; "}of which 0.25% (2) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />
            {" "}due to measurement uncertainty.
          </p>
          <p className="paragraph">
            No{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="multiple residues"
            />{" "}
            were reported in any of the samples.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Virgin olive oil",
    image: RiceBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 487 samples of virgin olive oil were analysed. No{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found in 75.4% (367) of samples. In 2.5% (12) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />
            , of which 0.8% (4) were reported as{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="non-compliant"
            />{" "}
            due to measurement uncertainty.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 9.2% (45) of samples. In one virgin olive oil sample coming from the EU, five different pesticides were reported: tebuconazole, cypermethrin, difenoconazole, lambda-cyhalothrin and deltamethrin. All results were within the permissible level.
          </p>
        </p>
      </Box>
    ),
  },
  {
    filter: "Wheat",
    image: RyeBlue,
    body: (
      <Box display="flex" justifyContent="center">
        <p style={{ maxWidth: "700px" }}>
          <p className="paragraph">
            A total of 658 samples of wheat were analysed, of which 196 samples were of wholemeal flour. No{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="pesticide residues"
            />{" "}
            were found in 35.0% (230) of samples. In 0.5% (3) of samples, the concentration{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="exceeded the MRL"
            />.{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Non-compliant"
            />{" "}samples were not reported.
          </p>
          <p className="paragraph">
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="Multiple residues"
            />{" "}
            were reported in 24.2% (159) of samples. In three wheat samples (two from the EU and one of unknown origin), five different pesticide residues were reported. The pesticides found in the samples were: glyphosate, deltamethrin, pirimiphos-methyl, chlormequat-chloride, azoxystrobin, tebuconazole, copper and fosetyl. All results were within the permissible level.
          </p>
        </p>
      </Box>
    ),
  },

];

const Intro = (props) => {
  const found = data.find((d) => d.filter === props.name);

  if (!found) {
    console.error(`No match found for ${props.name}`);
    return <div>No data available for this commodity.</div>;
  }

  return (
    <Box sx={{ textAlign: "center" }}>
      <Box>
        <img
          loading="lazy"
          class="img-fluid"
          alt="commodity icon"
          src={found.image}
          style={{ width: "50px" }}
        ></img>
      </Box>
      <p
        style={{
          textTransform: "uppercase",
          marginBottom: "0",
          color: "#22294D",
          fontSize: "10px",
        }}
      >
        Detailed results
      </p>
      <h3 style={{ fontSize: "24px" }}>{props.name}</h3>
      {found && found.body}
    </Box>
  );
};


export default Intro;
